import { Card } from '@app/components/various/Card';
import { Skeleton } from '@app/components/various/Skeleton';
import { useTableColumnsConfiguration } from '@app/utils/hooks/table/useTableColumnsConfiguration';

const ATTRIBUTE_LIST_KEYS = ['description', 'markets', 'createdDate', 'lastModifiedDate', 'lastPublishedDate'];

export const PagesListCardSkeleton = () => {
  const { columnsVisibility } = useTableColumnsConfiguration({ tableName: 'pages' });
  const skeletonRows = ATTRIBUTE_LIST_KEYS.filter(attribute => columnsVisibility[attribute]?.isVisible ?? false).length;

  return (
    <Card.Wrapper>
      {columnsVisibility.languages?.isVisible && <Card.Header isLoading />}
      <Card.Title isLoading />
      <Skeleton type="text" size="xsmall" width={25} />
      <Card.AttributeList isLoading skeletonRows={skeletonRows} />
    </Card.Wrapper>
  );
};
